import { Routes } from '@angular/router';

export const roleRoutes: Routes = [
   {
      path: 'roles',
      loadComponent: () => import('./view-roles/view-roles').then((c) => c.ViewRoles),
   },
   {
      path: 'roles/:uuid/permissions',
      loadComponent: () => import('./role-permissions/role-permissions').then(c => c.RolePermissions),
   },
];